import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      background: 'rgba(0, 0, 0, 0.3)',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '30px 20px',
      marginTop: 'auto'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '20px'
      }}>
        {/* Logo & Copyright */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '24px' }}>🤖</span>
          <div>
            <div style={{ color: 'white', fontWeight: '700', fontSize: '16px' }}>BrainForge</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}>
              © {new Date().getFullYear()} All rights reserved
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <Link 
            to="/terms" 
            style={{ 
              color: 'rgba(255,255,255,0.7)', 
              textDecoration: 'none', 
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#667eea'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
          >
            Terms of Service
          </Link>
          <Link 
            to="/privacy" 
            style={{ 
              color: 'rgba(255,255,255,0.7)', 
              textDecoration: 'none', 
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#667eea'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/refund" 
            style={{ 
              color: 'rgba(255,255,255,0.7)', 
              textDecoration: 'none', 
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#667eea'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
          >
            Refund Policy
          </Link>
          <a 
            href="mailto:support@multipowerai.com" 
            style={{ 
              color: 'rgba(255,255,255,0.7)', 
              textDecoration: 'none', 
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#667eea'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.7)'}
          >
            Contact
          </a>
        </div>

        {/* Tagline */}
        <div style={{ 
          color: 'rgba(255,255,255,0.5)', 
          fontSize: '12px',
          textAlign: 'right'
        }}>
          AI Collaboration Platform
        </div>
      </div>
    </footer>
  );
}
